import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import useEffectAsync from '../../../hooks/useEffectAsync'
import StatsLineChart from '../charts/StatsLineChart'
import { useThemeColor } from '../StatisticsPageContent'
import { client } from '../../../client'
import ChartNoData from '../charts/ChartNoData'

const ClientRegistrations = () => {
  const { t } = useTranslation('statisticsPage')
  const [data, setData] = useState([])
  const themeColor = useThemeColor()

  useEffectAsync(async () => {
    setData(await client.clientRegistrations())
  }, [])

  const title = t('clientRegistrations')
  if (!data.length) return <ChartNoData title={title} />

  const mapData = data.map((item) => {
    return {
      name: item.day,
      sum: item.sum
    }
  })

  const resData = {
    rawData: data,
    data: mapData,
    bars: [{ name: 'sum', color: themeColor }],
    title
  }
  return <StatsLineChart data={resData} />
}

export default ClientRegistrations
